
<div class="wrapper">
  <section id="area-breadcrumb" style="padding-top: 25px;">
    <div class="container">
      <div class="area-breadcrumb">
        <nav class="breadcrumb">
          <ul>
            <li><a href="/"><strong>Home</strong></a></li>
            <span><i class="fas fa-chevron-right"></i></span>
            <li>Perguntas Frequentes</li>
          </ul>
        </nav>
      </div>
    </div>
  </section>

  <section id="perguntas-frequentes">
    <div class="container">
      <div class="columns">
        <div class="area-texto column is-offset-1 is-10">
          <img class="icon-montreal" src="assets/img/logo-duvidas.png" alt="montreal-viagens-logo-duvida"/>
          <div class="menu-right">
            <ul class="nav-page">
              <li><a (click)="scroll('target_contatos')">Nossos Contatos</a></li>
              <li><a (click)="scroll('target_senha')">Problemas com Senha</a></li>
              <li><a (click)="scroll('target_reservas')">Reservas</a></li>
              <li><a (click)="scroll('target_plano')">Sobre o Plano</a></li>
              <li><a (click)="scroll('target_assuntos_financeiros')">Assuntos financeiros</a></li>
              <li><a (click)="scroll('target_clubes_parceiros')">Hotéis Parceiros</a></li>
            </ul>
          </div>
          <h1 class="title">Perguntas Frequentes</h1>
          <p>Tire suas dúvidas atráves das perguntas frequentes sobre a Montreal, como utilizar,
            reservar hotéis e melhor aproveitar suas diárias. </p>
        </div>
      </div>
    </div>
  </section>

  <section class="accordions" id="perguntas">
    <div class="container">
      <div class="columns">
        <div class="area-texto column is-offset-1 is-10">

          <div id="nossos-contato">
            <h5 id='target_contatos'>Nossos Contatos</h5>

            <div id="canais-atendimento" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-1" class="btn-control" />
              <label class="btn" for="btnControl-1">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Canais de Atendimento</strong><br>
                  </p>
                  <label class="area-check">
                    <p>Para sua comodidade, a Montreal possui vários canais de contato, sendo eles:</p>
                    <p><span class="negrito">Central de Atendimento ao Cliente:</span> 0800 610 3311</p>
                    <p><span class="negrito">Venda de Assinaturas de Hotéis:</span> 0800 610 2200</p>
                    <p>
                      <span class="negrito">Chat, </span>
                      <a target="_blank" href="https://sac-clubemontreal.ascbrazil.com.br/Chat/id/Clube_Montreal">
                        clicando aqui
                      </a>
                      <br>
                      <br>
                      <a target="_blank" href="https://www.instagram.com/clubemontreal/">Clique aqui</a>
                      para falar no <span class="negrito">Instagram</span> ou
                      <a target="_blank" href="https://www.facebook.com/ClubeMontreal/">aqui</a>
                      para mandar uma mensagem pelo
                      <span class="negrito">Facebook.</span>
                    </p>
                    <p>
                      Os canais acima estão disponíveis de segunda a sexta, das 9h às 18h, exceto feriados.
                    </p>
                    <p>
                      Quer atendimento todos os dias em qualquer horário? Fale com a Mel no
                      <span class="negrito">WhatsApp pelo (61) 99686-3311</span> ou
                      <a href="https://api.whatsapp.com/send?1=pt_BR&phone=5561996863311">clicando aqui.</a>
                    </p>
                  </label>
                </div>
              </label>
            </div>
          </div>

          <div id="problema-senha">
            <h5 id='target_senha'>Problemas com senha</h5>

            <div id="primeiro-acesso" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-4" class="btn-control" />
              <label class="btn" for="btnControl-4">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Primeiro acesso?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Assim que sua assinatura for aprovada, você receberá por e-mail sua
                      <span class="negrito">senha</span> de acesso a
                      <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>
                      e ao
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">Aplicativo.</a>
                      Seu <span class="negrito">usuário</span>
                      é seu CPF, está bem?
                    </p>
                    <p>
                      Se você não receber o e-mail, basta fazer o passo a passo de “Esqueci minha senha”:
                    </p>
                    <p>
                      Acesse o <span class="negrito">Comunidade do Cliente</span> e clique em “<span>Esqueci minha senha</span>”.
                      Depois é só <span class="negrito">informar o CPF</span> cadastrado da assinatura.
                      Enviaremos um <span class="negrito">e-mail.</span> com o link para redefinição de senha.
                      Caso não receba, confirme sua caixa de SPAM.
                    </p>
                    <p>
                      Em caso de dificuldades técnicas, a Mel pode te ajudar no <span class="negrito">WhatsApp</span>
                      a qualquer momento ou você pode falar com um de nossos atendentes na
                      <span class="negrito">Central de Atendimento ao Cliente</span>
                      de segunda a sexta-feira, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="esqueceu-senha" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-2" class="btn-control" />
              <label class="btn" for="btnControl-2">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Esqueceu a sua senha?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Acesse a <span class="negrito">Comunidade do Cliente</span> e clique em “<span class="negrito">Esqueci minha senha</span>”.
                      Depois é só <span class="negrito">informar o CPF</span> cadastrado na assinatura.
                      Enviaremos um e-mail com o link para redefinição de senha. Caso não receba,
                      confirme sua caixa de SPAM.
                    </p>
                    <p>
                      Em caso de dificuldades técnicas, a Mel pode te ajudar no
                      <span class="negrito">WhatsApp</span>
                      a qualquer momento ou você pode falar com um de nossos atendentes na
                      <span class="negrito">Central de Relacionamento ao Cliente</span> de segunda a sexta-feira, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="senha-bloqueada" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-3" class="btn-control" />
              <label class="btn" for="btnControl-3">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>A sua senha está bloqueada?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      É simples: basta solicitar uma nova. Você consegue fazer esse processo rapidamente pelo
                      nosso
                      <a href="http://api.whatsapp.com/send?1=pt_BR&amp;phone=5561996863311" target="_blank">WhatsApp.</a>
                      Ainda dá para alterar pela
                      <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>
                      e no
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">Aplicativo da Montreal</a>
                      na opção "<span class="negrito">Esqueci minha senha</span>”.
                      Se ainda assim tiver dificuldades, você pode falar com um de nossos atendentes na
                      <span class="negrito">Central de Atendimento ao Cliente</span> de segunda a sexta-feira, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>
          </div>

          <div id="reserva">
            <h5 id='target_reservas'>Sobre as Reservas</h5>
            <div id="calendario-reserva" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-13" class="btn-control" />
              <label class="btn" for="btnControl-13">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Calendário de Reserva</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Agora já não existe prazo <span class="negrito">mínimo</span>para marcação da sua reserva!
                      Você reservar seu hotel até para o mesmo dia, desde que haja disponibilidade no estabelecimento
                      hoteleiro escolhido. O prazo máximo de antecedência é de 90 dias corridos a data de check-in no hotel.
                      Consulte o Calendário no
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">Aplicativo</a>.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="marcacao-reserva" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-6" class="btn-control" />
              <label class="btn" for="btnControl-6">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Marcação de Reserva</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode realizar suas reservas pela
                      <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>,
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo da Montreal
                      </a>
                      ou pela Central de Atendimento ao Cliente no, <span class="negrito">0800 610 3311</span>.
                    </p>
<!--                    <p>-->
<!--                      Tenha em mente que o prazo mínimo para reservas é de 3 e o máximo de 12 semanas antes do-->
<!--                      check-in no hotel.-->
<!--                    </p>-->
                    <p>
                      <span class="negrito" style="text-decoration: underline">
                        Marcação online: Comunidade do Cliente e Aplicativo
                      </span>
                    </p>
                    <p>
                      Após acessar com seu login e senha, já na página principal você poderá realizar sua marcação.
                      Clique em “Pesquisar hotéis”, em seguida informe as
                      <span class="negrito">datas de entrada e saída</span>, o
                      <span class="negrito">tipo de quarto</span> e
                      <span class="negrito">quantidade hóspedes</span>
                      que deseja e clique em “<span class="negrito">Pesquisar hotéis</span>”.
                    </p>
                    <p>
                      Verifique os <span class="negrito">hotéis disponíveis</span> na lista e clique em
                      “<span class="negrito">Ver quartos</span>”. Verifique atentamente as informações do quarto desejado,
                      informe quantos quartos serão reservados e aperte
                      “<span class="negrito">Confirmar Quartos</span>”.
                      Ah! Lembre-se de já escolher o quarto conforme a disposição das camas que você deseja.
                    </p>
                    <p>
                      Agora, basta selecionar a quantidade de diárias necessárias para utilizar em sua
                      reserva clicando no ícone verde (adição). Quando já tiver diárias suficientes clique em
                      “Estou de acordo com o uso de “x” diárias da minha assinatura” e
                      em “Confirmar Reserva” para finalizar.
                    </p>
                    <p>
                      Se o hotel que você pesquisou não aparecer, significa que todos os quartos para a data informada
                      já foram ocupados. Além dos quartos contratados pela Montreal, o nosso sistema consegue consultar
                      100% da disponibilidade do hotel em tempo real, ou seja, se não apareceu para você aqui,
                      não conseguirá fazer através de sites de hospedagem ou até mesmo direto no hotel.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="alteracao-reserva" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-8" class="btn-control" />
              <label class="btn" for="btnControl-8">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Alteração na Reserva</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode solicitar alterações de data ou de hóspedes da sua reserva.
                      A alteração de data estará sujeita a disponibilidade de quartos no novo período e pode ser
                      necessário utilizar mais diárias, especialmente se a tarifa do hotel sofrer alterações.
                    </p>
<!--                    <p>-->
<!--                      A solicitação de alteração da reserva pode ou não ser aceita pelo estabelecimento hoteleiro e,-->
<!--                      nos casos negativos, a reserva volta à configuração original. Você pode realizar suas alterações-->
<!--                      pelo-->
<!--                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">-->
<!--                        Aplicativo da Montreal-->
<!--                      </a>-->
<!--                      ou pela Central de Atendimento ao Cliente no <span class="negrito">0800 610 3311</span>.-->
<!--                    </p>-->
                  </label>
                </div>
              </label>
            </div>

            <div id="cancelamento-reserva" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-10" class="btn-control" />
              <label class="btn" for="btnControl-10">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Cancelamento de Reserva</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A política de cancelamento de reserva pode variar conforme determinação de cada hotel.
                      Alguns hotéis trabalham com datas mais flexíveis (24h de antecedência) e outros podem informar
                      que independente da data, o cancelamento ocorrerá com multa. Você poderá consultar o prazo de
                      cancelamento no momento da marcação da reserva.
                    </p>
                    <p>
                      Você pode solicitar o cancelamento da reserva pela
                      <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo da Montreal
                      </a>
                      ou pela Central de Atendimento ao Cliente no <span class="negrito">0800 610 3311</span>.
                    </p>
                  </label>
                </div>
              </label>
            </div>

<!--            <div id="andamento-reserva" class=" div-filtro accordion">-->
<!--              <input type="checkbox" id="btnControl-18" class="btn-control" />-->
<!--              <label class="btn" for="btnControl-18">-->
<!--                <div class="perguntas">-->
<!--                  <p>-->
<!--                    <i class="fas fa-chevron-down"></i>-->
<!--                    <strong>Andamento da reserva</strong><br>-->
<!--                  </p>-->
<!--                  <label class="area-check">-->
<!--                    <p>-->
<!--                      Se você fez uma reserva e ela foi confirmada de imediato, você receberá um e-mail com os-->
<!--                      dados e confirmação de sua solicitação. Depois disso, é só aguardar o envio do voucher que-->
<!--                      chegará em até 21 dias antes do check-in também via e-mail. O andamento da sua solicitação-->
<!--                      pode ser consultado na-->
<!--                      <a (click)="goToClient()" target="_blank">-->
<!--                        Comunidade do Cliente-->
<!--                      </a>-->
<!--                      e no-->
<!--                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">-->
<!--                        Aplicativo-->
<!--                      </a>.-->
<!--                    </p>-->
<!--                  </label>-->
<!--                </div>-->
<!--              </label>-->
<!--            </div>-->

            <div id="emissao-voucher" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-11" class="btn-control" />
              <label class="btn" for="btnControl-11">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Emissão de Voucher</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Havendo disponibilidade, a sua reserva será confirmada imediatamente e você receberá por e-mail
                      o voucher de sua reserva que deverá ser apresentado no dia da chegada ao estabelecimento hoteleiro.
                      Ele é a garantia de sua hospedagem.
                      O voucher também pode ser consultado no
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo da Montreal
                      </a>
                      no menu “<span class="negrito">Reservas - Minhas Reservas</span>”.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="alteracao-hospede" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-5" class="btn-control" />
              <label class="btn" for="btnControl-5">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Alteração de Hóspede</strong><br>
                  </p>
                  <label class="area-check">
                    <p>Veja nossas opções e o passo a passo para alteração de hóspedes de sua reserva:</p>
                    <ul class="ul-disc">
                      <li>
                        <p>
                          Pelo
                          <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                            App da Montreal
                          </a>,
                          vá no menu e clique em “<span class="negrito">Reservas</span>”. Selecione a reserva que deseja
                          alterar e depois clique em “<span class="negrito">Hóspedes e camas</span>”, preencha os dados
                          e pressione o botão “<span class="negrito">Salvar</span>”.
                        </p>
                      </li>
                      <li>
                        <p>
                          Com a <span class="negrito">Mel</span> no
                          <a href="https://api.whatsapp.com/send/?phone=556121054094&text=Ol%C3%A1&app_absent=0" target="_blank">
                            WhatsApp
                          </a> e
                        </p>
                      </li>
                      <li>
                        <p>
                          Na <span class="negrito">Central de Atendimento ao Cliente no 0800 610 3311.</span>
                          O atendimento é de segunda a sexta das 9h às 18h, ok?
                        </p>
                      </li>
                    </ul>
                  </label>
                </div>
              </label>
            </div>

            <div id="hospedagem-crianca" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-14" class="btn-control" />
              <label class="btn" for="btnControl-14">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Hospedagem de Crianças</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A gratuidade para crianças depende da política de cada hotel, não sendo responsabilidade da Montreal.
                      No momento da pesquisa do hotel insira a quantidade de hóspedes já considerando a criança e a idade.
                      Serão exibidos somente os hotéis que tenham quartos disponíveis que atendam ao que foi pesquisado.
                    </p>
                    <p>
                      Além disso, fique de olho nas regras:
                    </p>
                    <p>
                      <span class="negrito">Crianças acompanhadas dos pais:</span>
                      apresentar os documentos de identificação da criança e dos pais.
                    </p>
                    <p>
                      <span class="negrito">Crianças desacompanhadas, com outros parentes ou terceiros:</span>
                      apresentar os documentos de identidade e autorização dos pais reconhecida em cartório, informando
                      a data de entrada e de saída do hotel. Ainda assim,
                      consulte o estabelecimento sobre a hospedagem de menores desacompanhados dos pais.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="solicitacao-cama-extra" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-12" class="btn-control" />
              <label class="btn" for="btnControl-12">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Solicitação de Cama Extra</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      No momento da marcação da reserva é importante inserir a quantidade de adultos e a quantidade
                      de crianças (caso haja), bem como a idade de cada uma.
                    </p>
                    <p>
                      Independente do plano contratado ser duplo ou triplo (2 ou 3 pessoas), você poderá marcar mais de
                      um quarto ou até mesmo um quarto para além da capacidade do seu plano. Para isso, pode ser necessário
                      o uso de mais diárias da sua assinatura.
                    </p>
                    <p>
                      Caso pretenda acomodar mais do que a capacidade informada no quarto, é necessário solicitar camas
                      extras diretamente com hotel, que poderá fornecê-las ou não, cabendo ao cliente o pagamento
                      das despesas extras correspondentes.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="regime-alimentacao" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-16" class="btn-control" />
              <label class="btn" for="btnControl-16">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Regimes de Alimentação</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Todos os planos da Montreal Viagens
                      <span class="negrito">possuem café da manhã incluso</span> e alguns deles contemplam
                      regime de alimentação, sendo eles:
                    </p>
                    <ul class="ul-disc">
                      <li>
                        <p>
                          <span class="negrito">Meia Pensão:</span>
                          almoço ou jantar
                        </p>
                      </li>
                      <li>
                        <p>
                          <span class="negrito">Pensão Completa:</span>
                          almoço e jantar
                        </p>
                      </li>
                      <li>
                        <p>
                          <span class="negrito">All Inclusive:</span>
                          todas as refeições + lanches + petiscos +bebidas a vontade
                        </p>
                      </li>
                    </ul>
                    <p>
                      Lembrando que não são todos os hotéis que oferecem regimes alimentação meia pensão,
                      pensão completa e All Inclusive, por isso, atente-se ao regime adotado pelo hotel no momento da
                      escolha do quarto.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="no-show" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-19" class="btn-control" />
              <label class="btn" for="btnControl-19">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>No Show</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      O não comparecimento ou atraso sem prévia notificação cancela sua reserva, além de deduzir as
                      diárias de sua assinatura de hotéis. Essa cobrança seguirá a política definida por cada hotel e
                      informada no momento da marcação da reserva.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="taxa-nao-comparecimento" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-15" class="btn-control" />
              <label class="btn" for="btnControl-15">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Taxa de Não Comparecimento</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      É a taxa cobrada pela Montreal pela falta de comparecimento do hóspede ao hotel, no
                      primeiro dia da hospedagem ou quando o pedido de cancelamento for solicitado fora do prazo
                      estabelecido pelo hotel, com a consequente perda das diárias e outros valores eventualmente
                      incluídos no custo da hospedagem.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="assuntos-financeiros" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-7" class="btn-control" />
              <label class="btn" for="btnControl-7">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Assuntos Financeiros</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode resolver questões financeiras da Montreal com a
                      <a href="https://api.whatsapp.com/send/?phone=556121054094&text=Ol%C3%A1&app_absent=0" target="_blank">
                        Mel no WhatsApp pelo (61) 99686-3311.
                      </a>
                      Já para <span class="negrito">pagamentos e negociações</span>
                      o atendimento é feito
                      <span class="negrito">somente na Central de Atendimento.</span>
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="consulta-disponibilidade-hotel" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-9" class="btn-control" />
              <label class="btn" for="btnControl-9">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Consulta de Disponibilidade de Hotéis</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Ao realizar a marcação de reserva, alguns hotéis podem não aparecer. Isso pode acontecer porque a
                      acomodação pode requerer um período mínimo de estadia, estar fechado por algum evento,
                      dentre outras possibilidades.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="reserva-terceiros" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-17" class="btn-control" />
              <label class="btn" for="btnControl-17">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Reserva para terceiros</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode marcar uma reserva para um amigo ou familiar. Basta realizar seu agendamento normalmente
                      na <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>
                      , em nosso
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo
                      </a>
                      ou na Central de Antedimento, <span class="negrito">0800 610 3311</span>.
                    </p>
                    <p>
                      Faça todas as suas escolhas e, ao final, insira os dados do Hóspede que irá usufruir das diárias.
                    </p>
                    <p>
                      Você também pode alterar os nomes dos hóspedes caso já tenha feito a reserva,
                      seguindo o passo a passo descrito em "<span class="negrito">Alteração na Reserva</span>".
                    </p>
                  </label>
                </div>
              </label>
            </div>

          </div>

          <div id="plano">
            <h5 id='target_plano'>Sobre o Plano</h5>

            <div id="alteracao-categoria" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-24" class="btn-control" />
              <label class="btn" for="btnControl-24">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Alteração da Assinatura - Mudança de Categoria</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode alterar sua assinatura (mudança de categoria) entre planos duplos e triplos ou entre
                      as modalidades de planos da Montreal (Completo, Ideal, Exclusivo, Requinte, Plus e Black).
                      Para fazer a alteração, solicite em nossa Central com um de nossos atendentes no
                      <span class="negrito">0800 610 3311</span>, de segunda a sexta-feira das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="saldo-diaria" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-23" class="btn-control" />
              <label class="btn" for="btnControl-23">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Saldo de diárias</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Consulte o saldo de diárias pela
                      <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>
                      ou em nosso
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo
                      </a>.
                      Aproveite também para verificar o período
                      aquisitivo de sua assinatura (data de renovação).
                      A consulta também pode ser realizada
                      por <span class="negrito">WhatsApp</span> com a Mel
                      <a href="https://api.whatsapp.com/send/?phone=556121054094&text=Ol%C3%A1&app_absent=0" target="_blank">
                        clicando aqui
                      </a>.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="forma-pagamento" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-25" class="btn-control" />
              <label class="btn" for="btnControl-25">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Forma de pagamento</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      As assinaturas de hotéis da Montreal Viagens podem ser adquiridas por
                      <span class="negrito">cartão de crédito</span>
                      (Visa, Master, American Express, Dinners Club, Elo e Hipercard).
                    </p>
                    <p>
                      Realize sua compra de forma segura e rápida aqui em nosso site. Basta acessar
                      <a (click)="goToCart()">aqui</a> e montar o plano ideal.
                      Se preferir, você também pode adquirir com um dos nossos
                      <span class="negrito">consultores no 0800 610 2200</span>
                      de segunda a sexta-feira, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="alteracao-cadastral" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-21" class="btn-control" />
              <label class="btn" for="btnControl-21">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Alteração Cadastral</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode alterar suas informações cadastrais em nossa na
                      <a (click)="goToClient()" target="_blank">Comunidade do Cliente</a>, no
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo da Montreal
                      </a> ou em nossa
                      <span class="negrito">Central de Atendimento ao Cliente no 0800 610 3311</span>
                      de segunda à sexta-feira, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="prorrogacao-periodo-aquisitivo" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-26" class="btn-control" />
              <label class="btn" for="btnControl-26">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Prorrogação Período Aquisitivo</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A prorrogação das diárias acontece automaticamente por mais 12 meses, desde que o plano permaneça
                      ativo, completando assim os 24 meses para utilização. Além dessa prorrogação, o cliente pode
                      solicitar mais 3 meses de prazo. Neste caso, será cobrada uma mensalidade a mais por cada mês
                      prorrogado. O novo período aquisitivo só será iniciado após a finalização da prorrogação.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="conversao-diaria" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-22" class="btn-control" />
              <label class="btn" for="btnControl-22">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Conversão de diárias</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Sendo cliente Montreal há pelo menos 1 ano é possível
                      <span class="negrito">utilizar as diárias</span> do período vigente
                      <span class="negrito">para realizar a conversão junto à Agência de Viagens Montreal</span>
                      na aquisição de produtos e serviços turísticos diversos.
                    </p>
                    <p>
                      Para mais informações sobre conversão de diárias, reservas internacionais, passagens aéreas,
                      pacotes turísticos, aluguel de carro, traslado e outros, o atendimento é realizado no
                      <span class="negrito">0800 610 3311</span>, opção 2, de segunda a sexta, das 9h às 18h.
                    </p>
                    <p>
                      As reservas internacionais, por estarem atreladas à conversão de diárias junto à Agência de
                      Viagens Montreal, que ao final se encarregará das marcações, estarão sujeitas às regras
                      operacionais da própria agência e da operadora internacional envolvida, além de dependerem
                      da disponibilidade de vagas nos estabelecimentos hoteleiros.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="cancelamento-plano" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-20" class="btn-control" />
              <label class="btn" for="btnControl-20">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Cancelamento do plano</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Para realizar o cancelamento do plano, ligue para a Montreal no
                      <span class="negrito">0800 610 3311</span>. Estamos por aqui de segunda a sexta, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

          </div>

          <div id="sobre-assuntos-financeiros">
            <h5 id='target_assuntos_financeiros'>Sobre assuntos Financeiros</h5>

            <div id="problemas-pagamento-assinatura" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-27" class="btn-control" />
              <label class="btn" for="btnControl-27">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Problemas no Pagamento da Assinatura</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Em caso de problemas no pagamento de sua assinatura, fale com a Mel no
                      <a href="https://api.whatsapp.com/send/?phone=556121054094&text=Ol%C3%A1&app_absent=0" target="_blank">
                        WhatsApp
                      </a>.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="ressarcimento" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-28" class="btn-control" />
              <label class="btn" for="btnControl-28">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Ressarcimento</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A Montreal poderá realizar o ressarcimento de hospedagens realizadas de forma particular
                      pelo cliente, podendo ser nacional ou internacional desde que:
                    </p>
                    <ul class="ul-disc">
                      <li>O cliente esteja ativo, ou seja, não pode estar inadimplente ou cancelado;</li>
                      <li>A reserva tenha ocorrido durante a vigência do período aquisitivo;</li>
                      <li>
                        A hospedagem tenha sido realizada em hotéis urbanos/fazenda, pousada ou resort, que estejam
                        devidamente autorizados a funcionar pelo Poder Público competente, sendo vedado o reembolso
                        de hospedagem em motel, hostel, Airbnb (e serviços congêneres), bem como sob a forma de
                        locação por temporada e
                      </li>
                      <li>
                        Seja apresentada a respectiva nota fiscal <span class="negrito">em nome do titular do plano</span>
                        e o respectivo comprovante de pagamento, em até 30 (trinta) dias após o check-out.
                      </li>
                    </ul>
                    <p>Confira agora algumas informações importantes:</p>
                    <ul class="ul-disc">
                      <li>
                        <p>Valor de ressarcimento máximo por diária:</p>
                        <p>
                          <span class="negrito">Básico Duplo: até R$ 169,52</span>
                          <br>
                          <span class="negrito">Básico Triplo: até R$ 205,80</span>
                        </p>
                        <p>
                          <span class="negrito">Completo Duplo: até R$ 279,64</span>
                          <br>
                          <span class="negrito">Completo Triplo: até R$ 337,37</span>
                        </p>
                        <p>
                          <span class="negrito">Ideal Duplo: até R$ 398,69</span>
                          <br>
                          <span class="negrito">Ideal Triplo: até R$ 461,58</span>
                        </p>
                        <p>
                          <span class="negrito">Exclusivo Duplo: até R$ 590,51</span>
                          <br>
                          <span class="negrito">Exclusivo Triplo: até R$ 655,57</span>
                        </p>
                        <p>
                          <span class="negrito">Requinte Duplo: até R$ 780,48</span>
                          <br>
                          <span class="negrito">Requinte Triplo: até R$ 845,55</span>
                        </p>
                        <p>
                          <span class="negrito">Plus Duplo: até R$ 970,43</span>
                          <br>
                          <span class="negrito">Plus Triplo: até R$ 1.035,43</span>
                        </p>
                        <p>
                          <span class="negrito">Black Duplo: até R$ 1.362,03</span>
                          <br>
                          <span class="negrito">Black Triplo: até R$ 1.436,56</span>
                        </p>
                      </li>
                      <li>
                        <p>Caso o valor seja inferior, ressarciremos de acordo com o valor estipulado no recibo.</p>
                      </li>
                      <li>
                        <p>
                          Para solicitar o ressarcimento, é necessário entrar em contato com nossa Central de Atendimento
                          pelo 0800 610 3311. Para iniciar o atendimento, é necessário estar com a nota fiscal da hospedagem
                          em mãos para nos passar algumas informações importantes. O serviço deve estar discriminado
                          na nota como “Hospedagem”, tá bem?
                        </p>
                      </li>
                      <li>
                        <p>
                          Ainda durante o contato telefônico, será solicitado o envio dos dados bancários do titular da
                          assinatura para realizar o reembolso. O prazo para devolução é de até 15 dias após o
                          recebimento da nota.
                        </p>
                      </li>
                      <li><p>Cópias de notas não serão aceitas.</p></li>
                      <li>
                        <p>
                          Mesmo que a hospedagem tenha sido realizada por terceiros, a nota deve ser emitida no
                          nome do titular do plano.
                        </p>
                      </li>
                    </ul>
                  </label>
                </div>
              </label>
            </div>

            <div id="extrato-utilizacao-diaria" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-29" class="btn-control" />
              <label class="btn" for="btnControl-29">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Extrato de Utilização de Diárias</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      O extrato de utilização de diárias está disponível
                      na
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>.
                      e no
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo
                      </a>.
                      Após realizar seu acesso, basta clicar em “<span class="negrito">Reservas - Minhas Reservas</span>”.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="alteracao-forma-pagamento" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-30" class="btn-control" />
              <label class="btn" for="btnControl-30">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Alteração da Forma de Pagamento</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Clientes que tenham cadastradas as formas de pagamento débito em conta ou boleto poderão solicitar
                      a alteração da forma de pagamento. Essa alteração pode ser realizada na
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>,
                      pelo
                      <a href="https://api.whatsapp.com/send/?phone=556121054094&text=Ol%C3%A1&app_absent=0" target="_blank">
                        WhatsApp
                      </a>
                      ou pela nossa
                      <span class="negrito">Central de Atendimento ao Cliente no 0800 610 3311</span>,
                      de segunda a sexta-feira, das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>
          </div>

          <div id="clube-hoteis-parceiros">
            <h5 id='target_clubes_parceiros'>Sobre o Clube e Hotéis parceiros</h5>

<!--            <div id="cartao-montreal" class=" div-filtro accordion">-->
<!--              <input type="checkbox" id="btnControl-31" class="btn-control" />-->
<!--              <label class="btn" for="btnControl-31">-->
<!--                <div class="perguntas">-->
<!--                  <p>-->
<!--                    <i class="fas fa-chevron-down"></i>-->
<!--                    <strong>Cartão Montreal</strong><br>-->
<!--                  </p>-->
<!--                  <label class="area-check">-->
<!--                    <p>-->
<!--                      A Montreal disponibiliza o cartão virtual para os clientes pelo-->
<!--                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">Aplicativo</a>.-->
<!--                      Ele não é necessário ser apresentado no ato do check-in bastando apenas levar o voucher da-->
<!--                      reserva e um documento pessoal.-->
<!--                    </p>-->
<!--                  </label>-->
<!--                </div>-->
<!--              </label>-->
<!--            </div>-->

            <div id="agencia-viagem" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-32" class="btn-control" />
              <label class="btn" for="btnControl-32">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Agência de Viagens</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A Montreal possui uma Agência de Viagens que oferece as demais soluções para sua
                      viagem como:
                    </p>
                    <ul class="ul-disc">
                      <li>Hotéis internacionais</li>
                      <li>Pacotes turísticos</li>
                      <li>Passagens aéreas</li>
                      <li>Aluguel de carro</li>
                      <li>Traslados</li>
                      <li>Ingressos para parques, entre outros</li>
                    </ul>
                    <p>
                      Para conhecer nossos serviços da Agência, consultar os valores e tirar dúvidas, entre em
                      contato com um de nossos consultores no 0800 610 3311, de segunda a sexta das 9h às 18h.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="montreal-mais" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-33" class="btn-control" />
              <label class="btn" for="btnControl-33">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Montreal+</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      O Programa de Vantagens Montreal + é mais um dos benefícios disponíveis para nossos
                      clientes. Quem faz parte do Clube de Assinatura da Montreal, garante descontos em vários
                      produtos e serviços de empresas parceiras.
                    </p>
                    <p>
                      São produtos como roupas, alimentos, eletrodomésticos, móveis, utilidades para o lar,
                      equipamentos esportivos, itens para pets, mochilas, brinquedos, cosméticos, informática,
                      automotivo e muito mais.
                    </p>
                    <p>
                      Já como destaque nos serviços temos descontos em cursos (graduação, pós-graduação,
                      mestrado, idiomas) academias, planos de celular, consertos automotivos, tratamentos
                      odontológicos e vários outros.
                    </p>
                    <p>
                      O cliente pode acessar os benefícios pela
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>
                      ou pelo
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        app da Montreal
                      </a>
                      sem sair de casa e com o conforto e segurança que merece.
                    </p>
                    <p>
                      Confira alguns parceiros:
                    </p>
                    <ul class="ul-disc">
                      <li>Magalu</li>
                      <li>Extra</li>
                      <li>Casas Bahia</li>
                      <li>Ponto Frio</li>
                      <li>Petz</li>
                      <li>Netshoes</li>
                      <li>Philips</li>
                      <li>Cia Toy</li>
                      <li>Riachuelo</li>
                      <li>Renner</li>
                      <li>E muitos outros</li>
                    </ul>
                  </label>
                </div>
              </label>
            </div>

            <div id="busca-hoteis-parceiros" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-34" class="btn-control" />
              <label class="btn" for="btnControl-34">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Busca de Hotéis Parceiros</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A lista de hotéis conveniados está disponível para pesquisa em nosso site
                      <a href="/hoteis">clicando aqui</a>,
                      na
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>
                      ou no
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        app da Montreal
                      </a>.
                      Lembramos que inclusões e exclusões de hotéis
                      na relação dos conveniados podem ocorrer a qualquer tempo e sem aviso prévio.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="informacao-hoteis-parceiros" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-35" class="btn-control" />
              <label class="btn" for="btnControl-35">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Informações dos Hotéis Parceiros</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A lista de hotéis parceiros está disponível para pesquisa em nosso site. Lá dentro da página do
                      hotel é possível consultar as informações da hospedagem como endereço do hotel,
                      comodidades, tipos de quarto disponíveis, entre outras informações.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="indicacao-amigo" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-36" class="btn-control" />
              <label class="btn" for="btnControl-36">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Indicação de Amigos</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Indique seus amigos e ganhe bônus* por cada indicação que seja convertida em novos clientes!
                    </p>
                    <p>
                      É isso mesmo: em nosso programa de <a href="/indique-e-ganhe">indicação de amigos</a>, nossos
                      clientes <span class="negrito">recebem bonificações</span> por cada indicação que seja convertida
                      em novos clientes, não possuindo limitações ou restrições acerca de quantas pessoas indicar.
                    </p>
                    <p>
                      Seus bônus serão utilizados como abatimento em seu plano de hospedagem no mês seguinte
                      ao pagamento de 4 parcelas dos planos de cada um dos seus amigos indicados.
                    </p>
                    <p>
                      Seus amigos merecem viajar com todas nossas vantagens e você com um ótimo desconto para
                      economizar, não é?
                    </p>
                    <ul class="ul-disc">
                      <li>Pagamento em 12x sem juros sem comprometer o limite do seu cartão</li>
                      <li>24 meses para utilizar, mediante renovação</li>
                      <li>Sem taxas de complemento e alimentação, nos hotéis disponíveis em cada categoria</li>
                      <li>Café da manhã incluso em todos os planos</li>
                      <li>Taxa de adesão grátis, mediante fidelização</li>
                    </ul>
                    <p>
                      Quer conhecer mais sobre nosso Programa de indicação ou inidicar um amigo?,
                      <a href="/indique-e-ganhe"
                         target="_blank">
                        clique aqui.
                      </a> e saiba mais
                    </p>
                    <p class="juridico">
                      *O valor máximo de recebimento do bônus está limitado ao plano Ideal de 7 diárias, duplo ou triplo,
                      dependendo da modalidade escolhida por seu amigo indicado.
                    </p>
                  </label>
                </div>
              </label>
            </div>

<!--            <div id="guru" class=" div-filtro accordion">-->
<!--              <input type="checkbox" id="btnControl-37" class="btn-control" />-->
<!--              <label class="btn" for="btnControl-37">-->
<!--                <div class="perguntas">-->
<!--                  <p>-->
<!--                    <i class="fas fa-chevron-down"></i>-->
<!--                    <strong>.Guru</strong><br>-->
<!--                  </p>-->
<!--                  <label class="area-check">-->
<!--                    <p>Seu próximo destino mais completo com a gente.</p>-->
<!--                    <p>-->
<!--                      O Grupo Montreal possui uma Agência de Viagem e um site de venda de produtos de turismo,-->
<!--                      o .Guru, para completar sua hospedagem realizada pelo nosso clube de assinatura.-->
<!--                    </p>-->
<!--                    <p>-->
<!--                      Pela Agência, nossos consultores estão aptos para atendê-los pelo telefone-->
<!--                      <a class="link-default" href="tel:0800613311">0800 610 3311</a>,-->
<!--                      de segunda a sexta-feira, das 9h às 18h. Já pelo .Guru, você pode adquirir seus produtos de forma-->
<!--                      simples, rápida e com muita segurança pelo site-->
<!--                      <a href="https://guruviagem.com.br/" target="_blank">guruviagem.com.br</a>-->
<!--                    </p>-->
<!--                  </label>-->
<!--                </div>-->
<!--              </label>-->
<!--            </div>-->

            <div id="checkin-checkout" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-38" class="btn-control" />
              <label class="btn" for="btnControl-38">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>O que significa check-in e check-out?</strong><br>
                  </p>
                  <label class="area-check">
                    <p><span class="negrito">Check-in:</span> data e hora de entrada do hóspede no Hotel.</p>
                    <p><span class="negrito">Check-out:</span> data e hora da saída do hóspede no Hotel.</p>
                  </label>
                </div>
              </label>
            </div>
          </div>

          <div id="perguntas-frequentes-item">
            <h5 id='target_perguntas_frequentes'>Perguntas Frequentes</h5>

            <div id="prazo-marcar-viagem" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-39" class="btn-control" />
              <label class="btn" for="btnControl-39">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Qual o prazo mínimo para marcar a minha viagem?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você poderá marcar reservas até com entrada para o mesmo dia e limitado a no máximo 90 dias
                      de antecedência da data do check-in. Lembrando que o cancelamento gratuito da reserva depende
                      da política adotada por cada hotel.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="quantos-anos-hospedagem-crianca" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-40" class="btn-control" />
              <label class="btn" for="btnControl-40">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>A partir de quantos anos é cobrada a hospedagem de crianças?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A gratuidade para a criança depende da política de cada hotel. Você pode verificar se existe a
                      gratuidade e a idade no momento da marcação, dentro do detalhamento do hotel no site da
                      Montreal. Ainda assim, entre em contato com o estabelecimento escolhido para verificar as
                      regras e informações sobre hospedagem dos pequenos.
                    </p>
                    <p>
                      Caso precise de cama extra, entre em contato diretamente com o hotel para verificar a
                      possibilidade.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="desistir-reserva-paga" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-41" class="btn-control" />
              <label class="btn" for="btnControl-41">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>E se eu desistir da reserva, pago alguma coisa?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode cancelar a sua reserva dentro do prazo estabelecido pelo hotel sem ônus.
                      Após este prazo poderá ser cobrada uma multa de cancelamento fora do prazo e
                      no show de valor parcial ou integral.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="como-marcar-reserva" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-42" class="btn-control" />
              <label class="btn" for="btnControl-42">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Como faço para marcar a minha reserva?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Você pode agendar a sua reserva na
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>,
                      pelo nosso
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo
                      </a>
                      ou ligando na Central de Atendimento, de segunda à sexta-feira das 9h às 18h no
                      <span class="negrito">0800 610 3311.</span>
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="pagar-outra-pessoa-plano" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-43" class="btn-control" />
              <label class="btn" for="btnControl-43">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Posso marcar para outra pessoa utilizar o meu Plano?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Para realizar reserva para terceiros, faça o processo normal de agendamento de reserva e,
                      antes de concluir a solicitação, preencha o nome do(s) hóspede(s).
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="tarifca-adicional-hotel" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-44" class="btn-control" />
              <label class="btn" for="btnControl-44">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Pago alguma outra tarifa adicional na hora de marcar o hotel?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Não. Na hora de marcar sua reserva você <span class="negrito">não</span> precisará se preocupar com
                      <span class="negrito">taxas extras</span> como complemento e o regime de alimentação.
                      Ta tudo incluso, de acordo com o hotel selecionado em cada categoria de plano!
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="oque-e-noshow" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-45" class="btn-control" />
              <label class="btn" for="btnControl-45">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>O que é  No Show?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      O no show é considerado quando o hóspede não comparece no check-in (primeiro dia da reserva)
                      ou ainda quando ocorre o cancelamento da reserva fora do prazo estabelecido pelo hotel.
                    </p>
                    <p>
                      Sempre que acontecer algum imprevisto antes do horário do check-in, entre em contato com o
                      hotel imediatamente. O não comparecimento ou atraso sem prévia notificação cancela sua
                      reserva, além de deduzir as diárias de sua assinatura de hotéis.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="comprovar-reserva" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-46" class="btn-control" />
              <label class="btn" for="btnControl-46">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>O que eu preciso levar para comprovar a minha reserva?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      É necessário apresentar o voucher no check-in. Você poderá baixá-lo na
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>.
                      ou em nosso
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo
                      </a>.
                      Pode ficar tranquilo: nós também enviaremos por SMS
                      e para o seu e-mail cadastrados. Mantenha sempre seus dados atualizados!
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="mensalidade-data-prevista" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-47" class="btn-control" />
              <label class="btn" for="btnControl-47">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Como saber se houve a cobrança da minha mensalidade na data prevista?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Faremos 5 tentativas de cobrança dos valores em aberto durante o período de 15 dias, sendo 1
                      tentativa a cada 3 dias. Nesse período você será informado por e-mail se o pagamento não ocorrer.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="alterar-data-vencimento" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-48" class="btn-control" />
              <label class="btn" for="btnControl-48">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Posso alterar a data de vencimento da minha assinatura no cartão de crédito?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      A data de vencimento da sua assinatura será sempre o dia em que você fizer a adesão ao nosso
                      plano e não é possível alterá-la.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="informacoes-seguras" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-49" class="btn-control" />
              <label class="btn" for="btnControl-49">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Minhas informações estão seguras com a Montreal Viagens?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Pode ficar tranquilo! Por aqui a segurança das suas informações é coisa séria! Além de utilizar os
                      melhores sistemas disponíveis no mercado, você tem controle total das suas informações.
                      Para sua segurança, nossa equipe não possui acesso aos seus dados bancários.
                      Somente você conseguirá visualizar os dados do cartão de crédito ou conta cadastrada.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="comprar-mais-diarias" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-50" class="btn-control" />
              <label class="btn" for="btnControl-50">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Posso comprar mais diárias?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Claro! Agora você pode incluir a partir de 1 diária em sua(s) assinatura(s) diretamente na
                      <a (click)="goToClient()" target="_blank">
                        Comunidade do Cliente
                      </a>,
                      , em nosso
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">
                        Aplicativo
                      </a>
                      ou pelas Centrais em 0800 610 2200 ou 0800 610 3311.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="hoteis-fora-categoria" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-51" class="btn-control" />
              <label class="btn" for="btnControl-51">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Posso me hospedar em hotéis fora da minha categoria?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      Hospede-se com mais flexibilidade! Além dos hotéis contratados em sua assinatura e mais opções
                      de categorias de quartos, você poderá usar mais diárias da sua assinatura para reservar um hotel
                      fora do seu plano.
                    </p>
                  </label>
                </div>
              </label>
            </div>

            <div id="renovacao-plano-hospedagem" class=" div-filtro accordion">
              <input type="checkbox" id="btnControl-52" class="btn-control" />
              <label class="btn" for="btnControl-52">
                <div class="perguntas">
                  <p>
                    <i class="fas fa-chevron-down"></i>
                    <strong>Quando ocorrerá a renovação do meu plano de hospedagem?</strong><br>
                  </p>
                  <label class="area-check">
                    <p>
                      O seu plano de hospedagem será renovado automaticamente.
                      <span class="negrito">Exemplo</span>: Se a contratação do plano foi
                      no dia 01/02/2022 as diárias serão válidas até 31/01/2023 e a
                      renovação ocorrerá exatamente no dia 01/02/2023.
                    </p>
                  </label>
                </div>
              </label>
            </div>
          </div>



          <h5>Ainda tem alguma dúvida? <br><small>Fale com a gente!</small></h5>
          <a href="/contatos" class="btn-verde">CONTATOS</a>
        </div>
      </div>
    </div>
  </section>

  <app-footer></app-footer>
</div>


